<template>
  <div id='login'>
    <img :src="imgBack" class="imgbackground"/>

    <div class="login-content">

      <div class="logo-top">
        <div class="logo-box">
          <img class="logo" :src="imgLogo" />
          <span class="logoTitle">{{$t('users.login.resourceManagement')}}</span>
        </div>
      </div>

      <div class="login-tab">
        <ul class="login-activeTab">
          <li
            v-for="item in activeTab"
            :class="{ active: active === item.dictValue }"
            @click="changeTab(item.dictValue)"
            :key="item.dictValue"
          >
            {{ item.dictLabel }}
          </li>
        </ul>
      </div>

      <div class="login-form">
        <el-form :model="loginForm" ref="LoginFormRef"
                 :rules="loginFormRules" v-show="active === '0'">
          <el-form-item prop="language">
            <el-select v-model="loginForm.language" popper-class="el-select" :popper-append-to-body="false" @change="switchLang">
              <div slot="prefix" class="inprefix">
                <span style="color: black">
                  <i class="fa fa-globe fa-lg"></i>
                </span>
                <span style="padding-left: 15px;">|</span>
              </div>
              <el-option
                v-for="item in languageList"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="username">
            <el-input v-model="loginForm.username" id="username" :placeholder="$t('users.login.pleaseinputusername')">
              <div slot="prefix" class="inprefix">
                <span style="color: black">
                  <i class="fa fa-user fa-lg"></i>
                </span>
                <span style="padding-left: 15px;">|</span>
              </div>
            </el-input>
          </el-form-item>
          <el-form-item prop="password">
            <el-input type="password" v-model="loginForm.password" id="password" :placeholder="$t('users.login.pleaseinputpassword')" show-password @keydown.enter.native="enterKeyUp">
              <div slot="prefix" class="inprefix">
                <span style="color: black">
                  <i class="fa fa-lock fa-lg"></i>
                </span>
                <span style="padding-left: 15px;">|</span>
              </div>
            </el-input>
          </el-form-item>
          <el-form-item>
            <span style="float: right;padding-right: 4px" @click="resetLoginForm">
              <el-button type="text" class="el-icon-refresh-right">{{$t('users.login.resetAccountPassword')}}</el-button>
            </span>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" class="login-btn" @click="login">{{$t('users.login.login')}}</el-button>
          </el-form-item>
        </el-form>
        <el-form v-show="active === '1'" style="text-align: center">
          <div id="login_container"></div>
        </el-form>
      </div>
    </div>

    <div class="login-bottom">
      <el-button type="text" disabled>Copyright © 2023-2025 迈思普电子股份有限公司 版权所有</el-button>
      <el-button type="text" disabled>粤ICP备18058470号-1</el-button>
    </div>
  </div>
</template>

<script>
import i18n from '../../i18n'
import { mapActions, mapMutations } from 'vuex'

export default {
  inject: ['reload'],
  name: 'Login',
  created () {
    this.$data.loginForm.language = localStorage.getItem('lang') || process.env.VUE_APP_I18N_LOCALE
    const oScript = document.createElement('script')
    oScript.type = 'text/javascript'
    oScript.src = 'https://res.wx.qq.com/connect/zh_CN/htmledition/js/wxLogin.js'
    document.body.appendChild(oScript)
  },
  mounted () {
    window.addEventListener('message', this.handleMessage)
    this.addEnterListener()
    document.getElementById('username').focus()
    this.loadExplorer()
    this.paraStr = this.$route.query.para
    this.setPage('HomePage')
  },
  beforeDestroy () {
    window.removeEventListener('message', this.handleMessage)
  },
  destroyed () {
    this.removeEnterListener()
  },
  data () {
    return {
      explorer: 0,
      paraStr: '',
      imgBack: require('../../assets/photo/loginback.png'),
      imgLogo: require('../../assets/photo/loginlogo.png'),
      loginForm: {
        language: '',
        username: '',
        password: ''
      },
      languageList: [
        {
          value: 'en',
          label: i18n.t('users.lang.en')
        },
        {
          value: 'zh_CN',
          label: i18n.t('users.lang.zh_CN')
        },
        {
          value: 'zh_TW',
          label: i18n.t('users.lang.zh_TW')
        }
      ],
      loginFormRules: {
        username: [
          {
            required: true,
            message: i18n.t('users.login.pleaseinputusername'),
            trigger: 'blur'
          },
          {
            min: 3,
            max: 10,
            message: i18n.t('users.login.usernamelength'),
            trigger: 'blur'
          }
        ],
        password: [
          {
            required: true,
            message: i18n.t('users.login.pleaseinputpassword'),
            trigger: 'blur'
          },
          {
            min: 6,
            max: 15,
            message: i18n.t('users.login.passwordlength'),
            trigger: 'blur'
          }
        ]
      },
      active: '0',
      activeTab: [
        { dictValue: '0', dictLabel: i18n.t('users.login.accountLogin') },
        { dictValue: '1', dictLabel: i18n.t('users.login.scanCodeLogin') }
      ]
    }
  },
  components: {
  },
  // 添加行为，
  methods: {
    ...mapMutations('cacheTabs', ['setPage']),
    ...mapActions('dynamicRouter', ['addMenuRouters']),
    handleMessage (res) {
      if (res.data.msgType === 'userMap') {
        window.sessionStorage.setItem('token', res.data.token)
        window.sessionStorage.setItem('currentSite', res.data.userDefSite)
        window.sessionStorage.setItem('currentHrSite', res.data.userDefHrSite)
        window.sessionStorage.setItem('currentEamSite', res.data.userDefEamSite)
        window.sessionStorage.setItem('defApp', res.data.userDefApplication)
        window.sessionStorage.setItem('currentUserCode', res.data.userCode)
        window.sessionStorage.setItem('currentUserName', res.data.userName)
        window.sessionStorage.setItem('currentUserDept', res.data.userDept)
        window.sessionStorage.setItem('currentUserDeptName', res.data.userDeptName)
        window.sessionStorage.setItem('currentUserEmp', res.data.userEmp)
        window.sessionStorage.setItem('currentUserWx', res.data.userOpenid)
        window.sessionStorage.setItem('currentUserVend', res.data.userVend)
        window.sessionStorage.setItem('currentUserTel', res.data.userTel)
        window.sessionStorage.setItem('currentUserPswType', res.data.userPswType)
        const moment = require('moment')
        const userPswDate = moment(res.data.userPswDate).format('YYYY-MM-DD')
        window.sessionStorage.setItem('currentUserPswDate', userPswDate)
        window.sessionStorage.setItem('currentUserGroup', res.data.userGroup)
        window.sessionStorage.setItem('currentUserEmail', res.data.userEmail)
        const userInfoDate = moment(res.data.userInfoDate).format('YYYY-MM-DD')
        window.sessionStorage.setItem('currentUserInfoDate', userInfoDate)
        if (res.data.userAdm) {
          window.sessionStorage.setItem('userAdm', res.data.userAdm)
        } else {
          window.sessionStorage.setItem('userAdm', '')
        }
        localStorage.setItem('lang', this.$data.loginForm.language)
        this.$router.push('/main')
      }
    },
    changeTab (item) {
      this.active = item
      if (this.active === '1') {
        const url = 'https://www.mspdz.com/#/loginwx?language=' + this.$data.loginForm.language
        // eslint-disable-next-line no-undef,no-unused-vars
        var obj = new WxLogin({
          self_redirect: true,
          id: 'login_container',
          appid: 'wxc7049d13409e192f',
          scope: 'snsapi_login',
          redirect_uri: encodeURIComponent(url),
          state: Math.random(),
          // style: 'white',
          href: 'data:text/css;base64,QGNoYXJzZXQgIlVURi04IjsKLmltcG93ZXJCb3ggLnFyY29kZSB7d2lkdGg6Mjk4cHg7fQouaW1wb3dlckJveCAudGl0bGUge2Rpc3BsYXk6IG5vbmU7fQouc3RhdHVzX2ljb24ge2Rpc3BsYXk6IG5vbmV9Ci5pbXBvd2VyQm94IC5zdGF0dXMge3RleHQtYWxpZ246IGNlbnRlcjt9IA=='
        })
      }
    },
    addEnterListener () {
      if (window.__completeEnterBind__) return
      window.addEventListener('keydown', this.enterCallback)
      window.__completeEnterBind__ = true
    },
    removeEnterListener () {
      window.removeEventListener('keydown', this.enterCallback)
      window.__completeEnterBind__ = false
    },
    enterCallback (e) {
      function findFormItem (el) {
        const parent = el.parentElement
        if (!parent) return document.body
        if (
          parent.className.includes('el-form-item') &&
          !parent.className.includes('el-form-item__content')
        ) {
          return parent
        }
        return findFormItem(parent)
      }
      function findInput (container) {
        let nextEl = container.nextElementSibling
        if (!nextEl) return
        let input = nextEl.querySelector('input')
        while (input.id === 'el-select') {
          nextEl = nextEl.nextElementSibling
          if (!nextEl) return
          input = nextEl.querySelector('input')
        }
        if (input.className.includes('el-input__inner')) return input
      }
      if (e.keyCode === 13) {
        const container = findFormItem(document.activeElement)
        if (container.tagName === 'BODY') {
          document.getElementById('username').focus()
        } else {
          findInput(container) && findInput(container).focus()
        }
      }
    },
    // 添加表单重置方法
    resetLoginForm () {
      // this=>当前组件对象，其中的属性$refs包含了设置的表单ref
      //   console.log(this)
      this.$refs.LoginFormRef.resetFields()
    },
    // 切换语言
    switchLang () {
      this.$i18n.locale = this.$data.loginForm.language
      localStorage.setItem('lang', this.$data.loginForm.language)
      this.reload()
    },
    enterKeyUp () {
      // return this.$message.error(i18n.t('users.login.userstatusnotvalid'))
      this.login()
    },
    login () {
      // 点击登录的时候先调用validate方法验证表单内容是否有误
      this.$refs.LoginFormRef.validate(async valid => {
        // 如果valid参数为true则验证通过
        if (!valid) {
          return
        }

        // 发送请求进行登录
        const { data: res } = await this.$http.post('/users/login', this.loginForm)
        if (res.meta.status !== 200) {
          return this.$message.error(i18n.t('users.login.loginfailed') + res.meta.msg) // console.log("登录失败:"+res.meta.msg)
        }

        if (res.data.userStatus) {
          if (res.data.userStatus !== 'A') {
            return this.$message.error(i18n.t('users.login.userstatusnotvalid'))
          }
          if (res.data.userWxLogin) {
            return this.$message.error('当前账号只允许扫码登录') // console.log("登录失败:"+res.meta.msg)
          }
          if (res.data.userGroup === 'MSP') {
            this.setPage('HomePage')
          } else if (res.data.userGroup === 'VEND') {
            this.setPage('ScmHomePage')
            if (res.data.userCheck) {
              return this.$message.error(i18n.t('users.login.noPermission'))
            }
          } else {
            return this.$message.error(i18n.t('users.login.noPermission'))
          }
          if (res.data.userWxLogin) {
            return this.$message.error('当前账号只允许扫码登录') // console.log("登录失败:"+res.meta.msg)
          }
          window.sessionStorage.setItem('token', res.data.token)
          window.sessionStorage.setItem('currentSite', res.data.userDefSite)
          window.sessionStorage.setItem('currentHrSite', res.data.userDefHrSite)
          window.sessionStorage.setItem('currentEamSite', res.data.userDefEamSite)
          window.sessionStorage.setItem('defApp', res.data.userDefApplication)
          window.sessionStorage.setItem('currentUserCode', res.data.userCode)
          window.sessionStorage.setItem('currentUserName', res.data.userName)
          window.sessionStorage.setItem('currentUserDept', res.data.userDept)
          window.sessionStorage.setItem('currentUserDeptName', res.data.userDeptName)
          window.sessionStorage.setItem('currentUserEmp', res.data.userEmp)
          window.sessionStorage.setItem('currentUserWx', res.data.userOpenid)
          window.sessionStorage.setItem('currentUserVend', res.data.userVend)
          window.sessionStorage.setItem('currentUserTel', res.data.userTel)
          window.sessionStorage.setItem('currentUserPswType', res.data.userPswType)
          const moment = require('moment')
          const userPswDate = moment(res.data.userPswDate).format('YYYY-MM-DD')
          window.sessionStorage.setItem('currentUserPswDate', userPswDate)
          window.sessionStorage.setItem('currentUserGroup', res.data.userGroup)
          window.sessionStorage.setItem('currentUserEmail', res.data.userEmail)
          const userInfoDate = moment(res.data.userInfoDate).format('YYYY-MM-DD')
          window.sessionStorage.setItem('currentUserInfoDate', userInfoDate)
          if (res.data.userAdm) {
            window.sessionStorage.setItem('userAdm', res.data.userAdm)
          } else {
            window.sessionStorage.setItem('userAdm', '')
          }
          localStorage.setItem('lang', this.$data.loginForm.language)
          this.$router.push('/main')
          // 导航至主页
          // const mainRoutes = [
          //   {
          //     path: '/main',
          //     name: 'Main',
          //     component: Main,
          //     meta: {
          //       title: i18n.t('users.login.title')
          //     }
          //   }
          // ]
          // this.addMenuRouters(mainRoutes)
        } else {
          return this.$message.error(i18n.t('users.login.userorpasswordnotesists'))
        }
      })
    },
    //  浏览器判断是否最新
    loadExplorer () {
      const that = this
      const agent = navigator.userAgent.toLowerCase()
      const regFf = /firefox\/[\d.]+/gi
      const regChrome = /chrome\/[\d.]+/gi
      const regSaf = /safari\/[\d.]+/gi
      //  firefox
      if (agent.indexOf('firefox') > 0) {
        const firefox = parseInt(agent.match(regFf)[0].slice(8, 10))
        if (firefox >= 54) {
          that.explorer = 1
        }
      }
      //  Chrome
      if (agent.indexOf('chrome') > 0) {
        const chrome = parseInt(agent.match(regChrome)[0].slice(7, 9))
        const chrome2 = parseInt(agent.match(regChrome)[0].slice(7, 10))
        if ((chrome >= 58) || (chrome2 >= 100)) {
          that.explorer = 1
        }
      }
      //  Safari
      if (agent.indexOf('safari') > 0 && agent.indexOf('chrome') < 0) {
        const safari = parseInt(agent.match(regSaf)[0].slice(7, 10))
        if (safari >= 537) {
          that.explorer = 1
        }
      }
      if (that.explorer === 0) {
        that.$message({
          showClose: true,
          type: 'warning',
          message: i18n.t('users.login.browserVersionLower')
        })
      } else {
        return {}
      }
    }
  }
}
</script>

<style lang="less" scoped>
#login {
  position: relative;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  height: 100%;
  background-size: cover;
  min-height: 570px;

  .imgbackground {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    z-index: -1;
  }
  .login-content {
    z-index: 99;
    position: absolute;
    right: 10%;
    min-width: 360px;
    min-height: 490px;
    width: 20%;
    height: 55%;
    border-radius: 14px;
    padding: 40px;
    -webkit-backdrop-filter: blur(3px);
    backdrop-filter: blur(3px);
    -webkit-transition: all 0.2s;
    transition: all 0.2s;
    background: linear-gradient(
      rgba(231, 231, 241, 0.5),
      rgba(255, 255, 255, 1)
    );

    .logo-top {
      .logo-box {
        display: flex;
        opacity: 1;
        .logo {
          width: 50px;
          height: 50px;
        }
        .logoTitle {
          height: 50px;
          line-height: 50px;
          font-size: 30px;
          font-weight: bolder;
          padding-left: 15px;
        }
      }
    }

    .login-tab {
      width: 100%;
      padding-bottom: 5px;

      .login-activeTab {
        display: flex;
        margin: 40px 0 40px;
        padding-left: 0px;
        li {
          font-size: 20px;
          line-height: 28px;
          color: #9f9f9f;
          cursor: pointer;
          transition: all 0.5s;
          margin: 0 40px 0 0;
          list-style-type: none;
        }
        li.active {
          font-size: 20px;
          font-weight: bold;
          color: #282828;
          opacity: 1;
          position: relative;
          list-style-type: none;
        }
      }

    }

    .login-form{

      .inprefix {
        min-height: 40px;
        width: 30px;
        font-size: 18px;
        padding-left: 15px;
        display: flex;
        justify-content: center;
        align-items: center
      }

      .el-select {
        ::v-deep .el-select-dropdown {
          .el-select-dropdown__item {
            font-size: 13px;
            line-height: 34px;
            height: 35px;
          }
        }

      }

      /deep/.el-form-item {
        margin-bottom: 30px;
      }

      /deep/.el-input__inner {
        padding-left: 70px;
        min-height: 40px;
        font-size: 15px;
        display: flex;
        justify-content: center;
        align-items: center;
      }

      .login-btn {
        width: 100%;
        padding: 15px;
        font-size: 22px;
        color: #ffffff;
        background: #5AAFFF;
      }
    }
  }

  .login-bottom {
    position: absolute;
    bottom: 10px;
    right: 10%;
    min-width: 360px;
    width: 20%;
    height: 80px;
    padding: 0px 40px;
    text-align: center
  }
}
</style>
